<template>
  <b-row>
    <b-col
      cols="6"
      align="center"
    ><b-button
      size="sm"
      class="icon-only"
      variant="danger"
      @click="onClickLimparAssinatura()"
    >
      <feather-icon icon="TrashIcon" /> </b-button></b-col>
    <b-col
      cols="6"
      align="center"
    >
      <b-button
        size="sm"
        class="icon-only"
        variant="primary"
        :disabled="!modificado"
        @click="onClickUndoAssinatura()"
      >
        <feather-icon icon="RotateCwIcon" />
      </b-button>
    </b-col>
    <b-col cols="12">
      <div
        id="canvas-container"
        class="mt-2"
      >
        <canvas
          ref="can"
          :anexo="redraw"
        />
      </div>
    </b-col>
    <b-col cols="12">
      <p class="text-sm text-center">
        Assinatura ou rúbrica.
      </p>
      <p class="text-sm text-center">
        Validade legal<br>
        <a
          href="http://www.planalto.gov.br/ccivil_03/_Ato2015-2018/2015/Decreto/D8539.htm"
          target="_blank"
        >Decreto 8.539 de 2015, Art. 6º § 1º</a>.
      </p>
    </b-col>
  </b-row>
</template>

<script>
import SignaturePad from 'signature_pad'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'AssinaturaPad',
  components: { FeatherIcon },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    anexo: Object,
  },
  data() {
    return {
      modificado: false,
    }
  },
  computed: {
    // utilizado somente para renderizar automaticamente o canvas
    // quando a propriedade anexo for atualizada
    redraw() {
      return this.anexo
    },
  },
  mounted() {
    const ref = this.$refs.can
    this.signaturePad = new SignaturePad(ref, {
      onEnd: () => {
        this.modificado = true
        this.$emit('assinado', this.signaturePad.toDataURL())
      },
    })
    if (this.anexo && this.anexo.url) {
      this.signaturePad.off()
      const context = ref.getContext('2d')
      const assinatura = new Image()
      assinatura.src = this.anexo.url
      assinatura.crossOrigin = 'anonymous'
      assinatura.onload = () => {
        context.drawImage(assinatura, 0, 0)
      }
    }
  },
  methods: {
    onClickLimparAssinatura() {
      this.signaturePad.on()
      this.modificado = true
      const ref = this.$refs.can
      this.signaturePad = new SignaturePad(ref, {
        onEnd: () => {
          this.modificado = true
          this.$emit('assinado', this.signaturePad.toDataURL())
        },
      })
    },
    onClickUndoAssinatura() {
      this.signaturePad.clear()
      this.modificado = false
      if (this.anexo && this.anexo.url) {
        const ref = this.$refs.can
        const context = ref.getContext('2d')
        const assinatura = new Image()
        assinatura.src = this.anexo.url
        assinatura.crossOrigin = 'anonymous'
        assinatura.onload = () => {
          context.drawImage(assinatura, 0, 0)
        }
      }
    },
  },
}
</script>

<style lang="scss">
#canvas-container {
  width: 100%;
  text-align: center;
}

canvas {
  display: inline;
  border: 1px dashed gray;
}
</style>
